import api from "src/config/api";
import { getQueryParamsFromFilter, handleResponseError } from "src/helper";
import {  hasSuccess } from "src/services/ApiHelpers";
import { appClient } from "src/services/NetworkService";

export async function getDashboard(dashboardFilter) {
  let url = `${api.itinerary_module.itinerary}/total`;
  if (dashboardFilter?.startDate) {
    url += `/?startDate=${dashboardFilter?.startDate}`;
  }
  if (dashboardFilter?.endDate) {
    url += `&endDate=${dashboardFilter?.endDate}`;
  }
  if (dashboardFilter?.type) {
    url += `&type=${dashboardFilter?.type}`;
  }

    const response = await appClient.get(url);
    return hasSuccess(response.data);

}

// fetch notification
export async function getNotification(notificationFilter) {
  const url = api.dashboard_module.notification;
  const queryParams = getQueryParamsFromFilter(notificationFilter);

  const response = await appClient.get(url + "?" + queryParams);
  return hasSuccess(response.data);
}

// update Notification Status
export async function updateNotificationStatus({ notificationId }: { notificationId: string }): Promise<AsyncResponseType> {
  const url = `${api.dashboard_module.changeNotificationStatus}/${notificationId}`;

  const response = await appClient.put(url);
  return response.data;
}

export async function getYearList() {
  const url = `${api.itinerary_module.years}`;
  try {
    const response = await appClient.get(url);
    return hasSuccess(response.data);
  } catch (error: any) {
    throw handleResponseError(error);
  }
}
